import { jsx as _jsx } from "react/jsx-runtime";
import { SanitizeHtml } from "../SanitizeHtml/SanitizeHtml";
var AgendaAbstract = function (_a) {
    var description = _a.description;
    return _jsx(SanitizeHtml, { stringToSanitize: description, tag: "div" });
};
export default AgendaAbstract;
